export default "__VITE_ASSET__DmdaxL8X__"